import { ReactElement } from 'react';
import { Flex } from '@cad-arc';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FailedToLoadError } from '../common/components/failed-to-load-error';
import { NoResults } from './no-results';

interface SearchResultsContentProps {
    isError: boolean;
    isInitialLoading: boolean;
    isNoResults: boolean;
    children?: ReactElement;
}

export function SearchResultsContent({
    isError,
    isInitialLoading,
    isNoResults,
    children,
}: SearchResultsContentProps) {
    if (isError) {
        return <FailedToLoadError noun="results" />;
    }

    if (isInitialLoading) {
        return (
            <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
                <LoadingIndicator />
            </Flex>
        );
    }

    if (isNoResults) {
        return <NoResults />;
    }

    return children ?? null;
}
